import React, { useState, useEffect, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import FormGroup from '../../../FormGroup';
import SelectGoalTree from '../../../SelectGoalTree/SelectGoalTree.container';
import TreeGoalActions from '../../../TreeGoalActions/TreeGoalActions';
import { I18nContext } from 'utils/I18n/context';

const PostbackGoalActions = ({ 
    goalActionIds, 
    goalActions, 
    modalIsVisible, 
    getGoalActions, 
    onAction, 
    getListCurGoals 
}) => {
    const { t } = useContext(I18nContext);
    const [state, setState] = useState({
        curIds: goalActionIds,
        list: [],
        isGlobal: !goalActionIds.length,
        modalIsVisible: modalIsVisible
    });

    const staticNames = t?.postbackPage?.creatingEditing || { 
        goalTitle: 'Goal Actions', 
        all: 'All' 
    };
    const staticActions = t?.actions || { add: 'Add' };

    const getList = useCallback((goalActionsList = goalActions) => {
        let list = [...state.list];

        state.curIds.map((id) => {
            let exist = !!state.list.find((item) => item.id === id);

            if (!exist) {
                let goalAction = goalActionsList.filter((item) => item.id === id);
                list = list.concat(goalAction);
            }
        });

        return list;
    }, [state.list, state.curIds, goalActions]);

    useEffect(() => {
        setState(prev => ({
            ...prev,
            list: getList()
        }));
        
        if (!state.list.length) {
            getGoalActions(state.curIds);
        }
    }, [getList, getGoalActions, state.curIds, state.list.length]);

    useEffect(() => {
        const isChangeGoalActionIds = goalActionIds !== state.curIds;
        let newState = {
            list: getList(goalActions)
        };

        if (isChangeGoalActionIds) {
            newState.curIds = goalActionIds;
        }

        setState(prev => ({ ...prev, ...newState }));
    }, [goalActionIds, goalActions, getList, state.curIds]);

    const toggleModal = useCallback((modifyGlobal) => {
        setState(prev => ({
            modalIsVisible: !prev.modalIsVisible,
            isGlobal: modifyGlobal ? false : prev.isGlobal
        }));
    }, []);

    const onDeleteGoal = useCallback((id) => {
        let list = JSON.parse(JSON.stringify(state.list));
        let curIds = JSON.parse(JSON.stringify(state.curIds));
        const indexList = list.findIndex((item) => item.id === id);
        const indexIds = curIds.indexOf(id);

        if (indexList !== -1) list.splice(indexList, 1);
        if (indexIds !== -1) curIds.splice(indexIds, 1);

        onAction(curIds);

        setState(prev => ({
            ...prev,
            curIds,
            list
        }));
    }, [state.list, state.curIds, onAction]);

    const onChangeGlobal = useCallback((value) => {
        const curIds = !!value ? [] : state.curIds;

        onAction(curIds);

        setState(prev => ({ ...prev, isGlobal: !!value }));
    }, [state.curIds, onAction]);

    const addGoalActions = useCallback((selectedGoalActions) => {
        let curIds = state.curIds;
        let list = [...state.list];

        curIds = curIds.concat(selectedGoalActions.map(item => item.id));
        list = list.concat(selectedGoalActions);

        setState(prev => ({
            ...prev,
            curIds,
            list
        }), () => {
            onAction(state.curIds);
        });
    }, [state.curIds, state.list, onAction]);

    return (
        <div className="form-horizontal">
            <h3 className="bold subtitle">{staticNames.goalTitle}</h3>
            <div>
                <button
                    className={`roundButton ${state.isGlobal ? 'roundButton--active' : ''}`}
                    onClick={() => onChangeGlobal(1)}
                >
                    {staticNames.all}
                </button>
                <button
                    className={`roundButton ${state.isGlobal ? '' : 'roundButton--active'}`}
                    onClick={() => toggleModal(true)}
                >
                    {staticActions.add}
                </button>
            </div>
           
            {state.curIds.length && !state.isGlobal
                ? (
                    <FormGroup
                        fieldClass="col-xs-12"
                    >
                        <pre className="m-t-sm postback__active-goal">
                            <TreeGoalActions
                                edit={true}
                                onAction={onDeleteGoal}
                                data={getListCurGoals(state.list, state.curIds)}
                            />
                        </pre>
                    </FormGroup>
                )
                : null
            }
            <SelectGoalTree
                modalIsVisible={state.modalIsVisible}
                blockedIdGoalActions={state.curIds}
                onCloseModal={toggleModal}
                onConfirm={addGoalActions}
            />
        </div>
    );
};

PostbackGoalActions.propTypes = {
    goalActionIds: PropTypes.array,
    goalActions: PropTypes.array,
    modalIsVisible: PropTypes.bool,
    getGoalActions: PropTypes.func,
    onAction: PropTypes.func,
    getListCurGoals: PropTypes.func
};

PostbackGoalActions.defaultProps = {
    goalActionIds: [],
    goalActions: [],
    modalIsVisible: false,
    getGoalActions: () => {},
    onAction: () => {},
    getListCurGoals: () => {}
};

export { PostbackGoalActions };
